<template>
  <div>
    Outbound messaging will be turned on for this participant.
  </div>
</template>

<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String
    }
  };
</script>